/* eslint react/prop-types: 0 */
import { useTranslation } from '@hotjar/translations';
import styled from '@emotion/styled';
import { TextField } from '../components/TextField';

const Container = styled('div')`
  padding: 0 15px 15px;
`;

export const Description = ({ description = '', onChange = () => {}, rtl }) => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.questions' });
  return (
    <Container>
      <TextField
        name="description"
        rtl={rtl}
        value={description}
        onChange={(evt) => onChange(evt.target.value)}
        multiline
        placeholder={t('description-placeholder')}
        aria-label={t('description-placeholder')}
      />
    </Container>
  );
};
